import { AxiosInstance } from 'axios';
import { BoardTemplate } from '../types/boardTemplate.types';

export interface ApplyBoardTemplateRequest {
  name: string;
  statuses: Array<{ name: string; isDone: boolean; scheduleDateDays?: number }>;
}

export class BoardTemplatesApi {
  constructor(private client: AxiosInstance) {}

  async getTemplates(): Promise<BoardTemplate[]> {
    const response = await this.client.get<BoardTemplate[]>('/api/boardtemplates');
    return response.data;
  }

  async applyToBoard(boardId: string, request: ApplyBoardTemplateRequest): Promise<void> {
    await this.client.put(`/api/boardtemplates/applytoboard/${boardId}`, request);
  }
}
